var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('Navbar'),_c('HomeHeader'),_c('div',{staticClass:"padding-branding"},[_c('AboutUs')],1),_c('div',{attrs:{"id":"services"}},[_c('Services')],1),_c('Newsletter'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }